<!-- ── Hero ──────────────────────────────────────────────── -->
<section class="hack-hero">
  <div class="hack-hero__media">
    <img src="/NHA/bg-banner.jpg" alt="" class="hack-hero__bg" />
    <div class="hack-hero__overlay"></div>
  </div>
  <div class="hack-hero__inner">
    <span class="hack-hero__tag">
      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>
      </svg>
      IISc Healthcare Innovation Challenge
    </span>
    <h1 class="hack-hero__title">AB PMJAY Auto-Adjudication<br />Hackathon</h1>
    <p class="hack-hero__subtitle">8th &amp; 9th May, 2026 &nbsp;·&nbsp; IISc Bengaluru</p>
  </div>
</section>

<!-- ── Section Tabs ──────────────────────────────────────── -->
<div class="hack-tabs">
  <div class="hack-tabs__inner">
    <button class="hack-tabs__btn" [class.active]="activeSection === 'problems'"
      (click)="setSection('problems')">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
      </svg>
      Problem Statements &amp; Awards
    </button>
    <button class="hack-tabs__btn" [class.active]="activeSection === 'masterclasses'"
      (click)="setSection('masterclasses')">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
        stroke-linecap="round" stroke-linejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
        <circle cx="9" cy="7" r="4"></circle>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
      </svg>
      Master Classes
    </button>
  </div>
</div>

<!-- ── Main Content ──────────────────────────────────────── -->
<main class="hack-main">
  <div class="hack-container">

    <!-- Problem Statements + Awards -->
    <section *ngIf="activeSection === 'problems'" class="hack-section">
      <div class="hack-section__header">
        <h2 class="hack-section__title">Problem Statements</h2>
        <p class="hack-section__subtitle">
          Choose a problem to solve. Each problem carries its own prize pool. All submissions must use the NHA Health
          Data Platform datasets.
        </p>
      </div>

      <!-- Awards intro banner -->
      <div class="hack-awards-banner">
        <div class="hack-awards-banner__icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="8" r="6"></circle>
            <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"></path>
          </svg>
        </div>
        <div>
          <strong>Attractive Cash Prizes for Winners</strong>
          <p>The finale of the Auto-Adjudication Hackathon will be hosted at IISc Bengaluru on 8th and 9th of May 2026.
            As part of the program, an award ceremony will be conducted to recognise outstanding solutions. Winner teams
            will be invited to deliver presentations before officials from the National Health Authority (NHA) and the
            Jury Panel.</p>
        </div>
      </div>

      <!-- Loading skeleton -->
      <div class="hack-problems__grid" *ngIf="isLoading">
        <div class="hack-problem-card hack-problem-card--skeleton" *ngFor="let n of [1,2,3]">
          <div class="skel skel--tag"></div>
          <div class="skel skel--title"></div>
          <div class="skel skel--desc"></div>
          <div class="skel skel--desc skel--short"></div>
        </div>
      </div>

      <!-- Problem cards with embedded prizes -->
      <div class="hack-problems__grid" *ngIf="!isLoading">
        <div class="hack-problem-card" *ngFor="let ps of problemStatements"
          (click)="openProblemStatement(ps)" role="button" tabindex="0"
          (keydown.enter)="openProblemStatement(ps)">

          <!-- Card header -->
          <div class="hack-problem-card__top">
            <span class="hack-problem-card__id">{{ ps.tag }}</span>
            <span class="hack-problem-card__diff" [ngClass]="difficultyClass(ps.difficulty)">
              {{ ps.difficulty }}
            </span>
          </div>

          <!-- Title + description -->
          <h3 class="hack-problem-card__title">{{ ps.title }}</h3>
          <p class="hack-problem-card__desc">{{ ps.description }}</p>

          <!-- Domain tag + view details -->
          <div class="hack-problem-card__footer">
            <span class="hack-problem-card__domain">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="3"></circle>
                <path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
                <path d="M4.93 4.93a10 10 0 0 0 0 14.14"></path>
              </svg>
              {{ ps.domain }}
            </span>
            <span class="hack-problem-card__view-link">
              View Details
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                stroke-linecap="round" stroke-linejoin="round">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
              </svg>
            </span>
          </div>

          <!-- Prize pool -->
          <div class="hack-problem-card__prizes">
            <div class="hack-problem-card__prize-label">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="8" r="6"></circle>
                <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"></path>
              </svg>
              Prize Pool
            </div>
            <div class="hack-problem-card__prize-rows">
              <div class="hack-problem-card__prize-row" *ngFor="let prize of ps.prizes; let i = index"
                [class.prize--gold]="i === 0" [class.prize--silver]="i === 1" [class.prize--bronze]="i === 2">
                <span class="prize__rank">{{ prize.rank }}</span>
                <span class="prize__amount">{{ prize.amount }}</span>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="hack-problem-card__sandbox-btn hack-problem-card__sandbox-btn--block"
            (click)="openSandbox(ps, $event)"
            (keydown.enter)="$event.stopPropagation(); openSandbox(ps, $event)"
            aria-label="Open in sandbox"
            [disabled]="isSandboxRedirecting || isSandboxDisabled(ps)"
          >
            {{
              isSandboxRedirecting && redirectingSandboxProblemId === ps.id
                ? 'Opening...'
                : 'Open in sandbox'
            }}
          </button>

        </div>
      </div><!-- /hack-problems__grid -->
    </section>

    <!-- Master Classes -->
    <section *ngIf="activeSection === 'masterclasses'" class="hack-section">
      <div class="hack-section__header">
        <h2 class="hack-section__title">Master Classes</h2>
        <p class="hack-section__subtitle">
          Learn from leading experts across healthcare AI, NLP, and responsible technology.
        </p>
      </div>
      <!-- Loading skeleton -->
      <div class="hack-mc__list" *ngIf="isLoading">
        <div class="hack-mc-card hack-mc-card--skeleton" *ngFor="let n of [1,2,3]">
          <div class="hack-mc-card__date-col">
            <div class="skel skel--date"></div>
            <div class="skel skel--date skel--short"></div>
          </div>
          <div class="hack-mc-card__divider"></div>
          <div class="hack-mc-card__body">
            <div class="skel skel--tag"></div>
            <div class="skel skel--title"></div>
            <div class="skel skel--desc"></div>
          </div>
        </div>
      </div>

      <div class="hack-mc__list" *ngIf="!isLoading">
        <div class="hack-mc-card" *ngFor="let mc of masterClasses">
          <div class="hack-mc-card__date-col">
            <span class="hack-mc-card__date">{{ mc.date }}</span>
            <span class="hack-mc-card__time">{{ mc.time }}</span>
            <span class="hack-mc-card__mode">{{ mc.mode }}</span>
          </div>
          <div class="hack-mc-card__divider"></div>
          <div class="hack-mc-card__body">
            <div class="hack-mc-card__tags">
              <span class="hack-mc-card__tag" *ngFor="let tag of mc.tags">{{ tag }}</span>
            </div>
            <h3 class="hack-mc-card__title">{{ mc.title }}</h3>
            <p class="hack-mc-card__desc">{{ mc.description }}</p>
            <div class="hack-mc-card__speaker">
              <div class="hack-mc-card__avatar">{{ mc.speaker.charAt(0) }}</div>
              <div>
                <span class="hack-mc-card__speaker-name">{{ mc.speaker }}</span>
                <span class="hack-mc-card__speaker-meta">{{ mc.designation }}, {{ mc.organisation }}</span>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /hack-mc__list -->
    </section>

  </div>
</main>

<app-footer></app-footer>
<app-login-modal *ngIf="showLoginModal" (visibleChange)="showLoginModal = false"></app-login-modal>
